import { ISearchQueryParams } from "../redux/common/common.types";

export const getSearchQueryV2 = ({
  page,
  rowsPerPage,
  status,
  value,
  columns,
  date,
  limit,
  advancedFilters,
  isDownloading,
}: ISearchQueryParams): string => {
  const params = new URLSearchParams();

  if (status && status !== "-1") {
    params.append("status", status);
  }

  if (columns?.length && value) {
    params.append("columns", columns.join(","));
    params.append("value", value);
  }

  if (date?.fromDate) {
    params.append("from_date", date.fromDate);
  }

  if (date?.toDate) {
    params.append("to_date", date.toDate);
  }

  if (advancedFilters?.length) {
    params.append(
      "advanceFilter",
      JSON.stringify(advancedFilters)
    );
  }

  if (page) {
    params.append("pageNo", String(page));
  }

  if (rowsPerPage) {
    params.append("itemPerPage", String(rowsPerPage));
  }

  if (limit) {
    params.append("pageLimit", String(limit));
  }

  if (isDownloading) {
    params.append("isDownloading", "true");
  }

  return params.toString();
};